import locationActionTypes from "../types/locationActionTypes";

const initialState = {
    locations: [],
    stateInfo: {
        isLoading: false,
        isSuccess: false,
        isError: false,
        error: null
    }
};

const locationReducer = (state = initialState, action) => {
    switch (action.type) {
        case locationActionTypes.START_GET_LOCATION:
        case locationActionTypes.START_ADD_LOCATION:
        case locationActionTypes.START_DELETE_LOCATION:
            return setStateLoading(state, action);

        case locationActionTypes.GET_LOCATION_SUCCESS:
            return getLocationSuccess(state, action);
        case locationActionTypes.ADD_LOCATION_SUCCESS:
        case locationActionTypes.DELETE_LOCATION_SUCCESS:
            return setActionSuccess(state, action);

        case locationActionTypes.GET_LOCATION_FAILURE:
        case locationActionTypes.ADD_LOCATION_FAILURE:
        case locationActionTypes.DELETE_LOCATION_FAILURE:
            return setActionFailed(state, action);

        default:
            return state;
    }
}

const setStateLoading = (state, action) => {
    return {
        ...state,
        stateInfo: {
            ...state.stateInfo,
            isLoading: true,
            isSuccess: false,
            isError: false,
            error: null
        }
    };
}

const setActionSuccess = (state, action) => {
    return {
        ...state,
        stateInfo: {
            isLoading: false,
            isSuccess: true,
            isError: false
        },
    };
}

const setActionFailed = (state, action) => {
    return {
        ...state,
        stateInfo: {
            isLoading: false,
            isSuccess: false,
            isError: true,
            error: action.payload
        },
    };
}

const getLocationSuccess = (state, action) => {
    return {
        ...state,
        stateInfo: {
            isLoading: false,
            isSuccess: true,
            isError: false
        },
        locations: action.payload
    };
}

export default locationReducer;